import type {ReactNode} from 'react';
import {Search} from 'lucide-react';
import {cn} from '../lib/cn';

export type SearchButtonProps = {
  onClick?: () => void;
  className?: string;
  icon?: ReactNode;
  ariaLabel?: string;
};

export function SearchButton({onClick, className, icon, ariaLabel}: SearchButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'p-1.5 text-[var(--chekin-neutral-500)] hover:text-[var(--chekin-color-brand-blue)]',
        className,
      )}
      data-testid="search-button"
      aria-label={ariaLabel}
      type="button"
    >
      {icon || <Search size={12} strokeWidth={4} />}
    </button>
  );
}
